import { Badge, Box, Button, CircularProgress, Dialog, FormHelperText, IconButton, TextField, Typography, useTheme } from '@mui/material'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { toast } from 'react-toastify'
import dayjs from 'dayjs'

import { convertToCDNLink, formatVideoDuration, getTimePassedFrom, Icons, leadingZeroFormatter } from '../../../utils/utilities'
import { useOnlineSessionsStore } from '../../../store/onlinesessions.store'
import TryAgainMessageBlock from '../../common/TryAgainMessageBlock'
import { useSettingsStore } from '../../../store/settings.store'
import DataLoadingSpinner from '../../common/DataLoadingSpinner'
import CustomTable from '../../common/custom-table/CustomTable'
import VideoPlayer from '../../common/video-player/VideoPlayer'
import noRecordingsImg from '../../../assets/norecording.svg'
import AddNewRecordingButton from './AddNewRecordingButton'
import noRequestsImg from '../../../assets/no-details.svg'
import { useUserStore } from '../../../store/user.store'
import ConfirmDialog from '../../common/ConfirmDialog'
import CustomTooltip from '../../common/CustomTooltip'
import CustomChip from '../../common/CustomChip'
import api from '../../../service/api'
import CustomImage from '../../../shared/components/common/CustomImage'
import { isUrlAccessible } from '../../../shared/utils/utilities'


const requestsTableColumns = [
    { name: "Sl. No.", width: "100px", align: "center", field: "index", index: true },
    { name: "AUID", field: "user_id", width: "120px" },
    { name: "Student Name", field: "user_name", width: "250px", maxWidth: "350px" },
    {
        name: "Reason", width: "150px", field: "reason", renderCell: row => <CustomTooltip title={row.override_reason || ""}>
            <Typography maxWidth="110px" fontSize="inherit" noWrap>{row.override_reason || "-"}</Typography>
        </CustomTooltip>
    },
    { name: "Requested At", width: "150px", field: "created_at", renderCell: override => dayjs( override.created_at ).format( "LLL" ) },
]

const AccessTimeUpdateDialog = observer( ( { setOpen, open } ) => {

    const [acceptingRequests, setAcceptingRequests] = useState( false )
    const [listfilter, setListfilter] = useState( "accepted" )
    // const [selected, setSelected] = useState( [] )

    const { border, layout, palette } = useTheme()

    const { meeting_id } = useParams()

    const OnlineSessionsStore = useOnlineSessionsStore()

    const requests = OnlineSessionsStore.getAccessTimeExtentionRequests
    const error = OnlineSessionsStore.getErrors.getAccessTimeExtentionRequests

    const { initialLoad: loading, refreshing } = OnlineSessionsStore.getHybridClassAccessTimeExtensionRequestsLoadingStatus

    // const extendTime = async () => {
    //     try {
    //         const validIds = new Set( selected )

    //         if ( validIds.size === 0 )
    //             return
    //         const payload = {
    //             overrides: Array.from( validIds )
    //         }
    //         setAcceptingRequests( true )
    //         await api.onlineMeetings.extendHybridClassVideoTime( meeting_id, payload )
    //         await OnlineSessionsStore.fetchHybridClassAccessTimeExtensionRequests( meeting_id )
    //         setSelected( [] )


    //     } catch ( err ) {
    //         toast( err?.response?.data?.message || "Failed to delete the video please try again." )
    //     } finally {
    //         setAcceptingRequests( false )
    //     }
    // }

    const refreshRequestsList = useCallback( async () => {
        OnlineSessionsStore.fetchHybridClassAccessTimeExtensionRequests( meeting_id )
    }, [meeting_id, OnlineSessionsStore] )

    useEffect( () => {
        if ( OnlineSessionsStore.getErrors.getAccessTimeExtentionRequests ) {
            refreshRequestsList()
        }
    }, [OnlineSessionsStore, refreshRequestsList] )


    return (
        <Dialog onClose={() => setOpen( false )} open={open} >
            <Box padding="10px 20px" borderBottom={border[1]} gap={layout.cardsGap} display="flex" alignItems="center" justifyContent="space-between">
                <Typography variant="h1" fontWeight="500" component="h1" fontSize="16px">Access Time Overrides</Typography>
                <IconButton color='greyed' disabled={acceptingRequests || loading} onClick={() => setOpen( false )} >{Icons.default.CloseIcon}</IconButton>
            </Box>
            {!error && <Box padding="20px" display="flex" flexDirection="column" gap={layout.cardsGap}>

                {requests.length > 0 && <Box display="flex" gap={layout.cardsGap} justifyContent="space-between" alignItems="flex-end" flexWrap="wrap">
                    <Typography variant='subtitle2' color='textSecondary'>{requests.length} override{requests.length > 1 ? "s" : ""} </Typography>
                    <Button variant='outlined' color='primary' disabled={refreshing} onClick={refreshRequestsList} startIcon={refreshing ? <CircularProgress size={16} /> : Icons.default.Replay} size='small' >Refresh list</Button>
                    {/* {listfilter === "accepted" && requests.length > 0 && <Button variant='outlined' color='secondary' onClick={() => setListfilter( prev => prev === "accepted" ? "pending" : "accepted" )} startIcon={Icons.default.Pending} size='small' >{listfilter ? "Show pending requests" : "Show Accepted Requests"}</Button>} */}
                </Box>}

                {requests.length > 0 && <CustomTable dataIdKey="user_id" columns={requestsTableColumns} data={requests} />}

                {requests.length === 0 && <Box borderRadius={layout.borderRadius} padding="20px" display="flex" flexDirection="column" gap="20px" alignItems="center">
                    <Box component="img" width="200px" src={noRequestsImg} />
                    <Typography textAlign="center" variant='subtitle2'>{listfilter === "accepted" ? "No overrides found" : "No pending requests!"}</Typography>
                    <Box display="flex" justifyContent="center" flexDirection={{ xs: "column-reverse", sm: "row" }} gap={layout.cardsGap} alignItems="center" flexWrap="wrap">
                        <Button variant='outlined' disabled={refreshing} color='greyed' onClick={refreshRequestsList} startIcon={refreshing ? <CircularProgress size={16} /> : Icons.default.Replay} size='small' >Refresh list</Button>
                        {/* <Button variant='outlined' color='secondary' onClick={() => setListfilter( prev => prev === "accepted" ? "pending" : "accepted" )} startIcon={Icons.default.CheckCircleIcon} size='small' >{listfilter === "accepted" ? "Show pending requests" : "Show Accepted Requests"}</Button> */}
                    </Box>
                </Box>}
            </Box>}
            {/* {!error && listfilter === "pending" && selected.length > 0 && <Box padding="20px" display="flex" justifyContent="flex-end" gap="10px">
                <Button onClick={extendTime} disabled={acceptingRequests || loading} color='primary' variant='contained' disableElevation size='small' startIcon={acceptingRequests ? <CircularProgress size={14} /> : Icons.default.Clock}>Extend time for selected</Button>
            </Box>} */}
            {error && <TryAgainMessageBlock err={error?.message} code={error?.code} getData={refreshRequestsList} loading={refreshing} />}
        </Dialog>
    )
} )

const HybridClassVideo = observer( ( { playVideo, video } ) => {

    const [confirmDeleteDialogOpen, setConfirmDeleteDialogOpen] = useState( false )
    const [deleting, setDeleting] = useState( false )

    const OnlineSessionsStore = useOnlineSessionsStore()
    const SettingsStore = useSettingsStore()
    const UserStore = useUserStore()

    const meeting = OnlineSessionsStore.getSessionMetadata
    const { user_id: currentUserId } = UserStore.getUser

    const { palette, border, layout } = useTheme()
    const { meeting_id } = useParams()

    const deleteVideo = async () => {
        try {
            setDeleting( true )
            await api.onlineMeetings.removeRecordingAssignmentFromClass( video.recording_assignment_id )
            OnlineSessionsStore.fetchOnlineSessionRecordings( meeting_id )
        } catch ( err ) {
            toast( err?.response?.data?.message || "Failed to delete the video please try again." )
        } finally {
            setDeleting( false )
        }
    }

    const play = async () => {
        try {
            const key = video.recording_key || video.file_key
            if ( !key ) return

            const streamSource = SettingsStore.getSettingValueFromKey( 'hybrid_class_stream_source', 'spaces' )

            if ( streamSource === 'cdn' ) {
                const cdnUrl = convertToCDNLink( video?.recording_metadata?.location || video?.file_details?.location )
                if ( await isUrlAccessible( cdnUrl ) ) {
                    playVideo( cdnUrl, video )
                    return
                }
            }
            // const { data: { data: url } } = await api.recording.fetchMeetingRecordingSignedUrl( meeting_id, { key: key, register_watch: false, legacy: !!video.file_key } )
            const { data: { data: url } } = await api.recording.fetchHybridClassRecordingSignedUrl( meeting_id, video.id, { key, register_watch: false, legacy: !!video.file_key } )
            playVideo( url, video )

        } catch ( err ) {
            toast( err?.response?.data?.message || "Something went wrong while fetching video!" )
        }
    }

    return (
        <Box sx={{ ":hover": { borderColor: palette.text.secondary } }} border={border[1]} justifyContent="space-between" padding="5px 10px" display="flex" alignItems="center" gap="10px" borderRadius="5px" bgcolor={palette.contentBg}>

            <ConfirmDialog waiting={deleting} status={confirmDeleteDialogOpen} confirmAction={deleteVideo} actionName='Confirm Delete' message='The video will be removed for the class permanently.' cancelAction={() => setConfirmDeleteDialogOpen( false )} />
            <Box component="button" onClick={play} sx={{ border: "none", textAlign: "left", cursor: "pointer", flexDirection: { xs: "column", sm: "row", alignItems: "flex-start", background: palette.contentBg } }} display="flex" flexGrow={1} gap="10px" >

                <Box border={border[1]} borderRadius="5px" overflow="clip" sx={{ aspectRatio: "16 / 9" }} height={{ xs: "auto", sm: "120px" }} position="relative" flexShrink={0}>
                    {video?.thumbnail_metadata?.location ?
                        <CustomImage src={video.thumbnail_metadata?.location} /> :
                        <Box display="flex" alignItems="center" justifyContent="center" height="100%" bgcolor={palette.contentBg} color="text.secondary" fontSize="32px">
                            {Icons.default.OndemandVideoIcon}
                        </Box>
                    }
                    <Box position="absolute" display="flex" alignItems="center" justifyContent="center" sx={{ inset: 0, color: palette.text.primary }} fontSize="40px"  >
                        <Typography fontSize="18px" display="flex" alignItems="center" justifyContent="center" bgcolor={palette.contentBg} width="30px" borderRadius="50%" sx={{ boxShadow: 5, aspectRatio: "1 / 1" }} >{Icons.default.PlayArrowIcon}</Typography>
                    </Box>
                    {video.recording_metadata?.duration && <Box position="absolute" display="flex" alignItems="center" justifyContent="center" sx={{ bottom: 2, right: 2, color: palette.text.primary }}   >
                        <Typography fontSize="10px" borderRadius="5px" padding="1px 3px" display="flex" alignItems="center" justifyContent="center" bgcolor={palette.contentBg}>{formatVideoDuration( video.recording_metadata.duration )}</Typography>
                    </Box>}
                </Box>

                <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>
                    <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "flex-start" }}>
                        <Typography className='truncate-at-2' gutterBottom sx={{ fontSize: "1rem", fontWeight: 600 }} component="h3">
                            {video.title}
                        </Typography>
                        {video.expired && <CustomChip variant="semifilled" color="error" value="Expired" />}
                    </Box>
                    <Box sx={{ my: 1 }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "text.secondary", fontSize: "0.75rem" }} >TOPICS COVERED</Typography>
                        <Box gap="5px" alignItems="center" display="flex" flexWrap="wrap">
                            {video.topics_covered?.map( topic => (
                                <CustomChip key={topic} value={topic} />
                            ) )}
                        </Box>
                        {( !video.topics_covered || video.topics_covered.length === 0 ) && <Typography variant='subtitle2' color="textDisabled" component="em" sx={{ fontSize: "0.75rem" }} >Topics not available</Typography>}
                    </Box>
                    <Box>
                        <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "text.secondary", fontSize: "0.75rem", mb: 1 }} >UPLOAD DETAILS</Typography>
                        <Box display={{ xs: "none", md: "flex" }} gap="5px" alignItems="center" flexWrap="wrap">
                            {video.expired && <CustomChip value={`Expired at: ${dayjs( video.endDate ).format( "LLL" )}`} />}
                            {!video.expired && <CustomChip color="error" tooltipTitle='Students should watch this video before this time to get marked as present for the class.' value={`Expires at: ${dayjs( video.endDate ).format( "LLL" )}`} />}
                            <CustomChip value="Manual Upload" />
                            <CustomChip value={`Uploaded at: ${dayjs( video.uploaded_at ).format( "LLL" )}`} />
                        </Box>
                        <Box display={{ xs: "flex", md: "none" }} gap="5px" alignItems="center" flexWrap="wrap">
                            {video.expired && <CustomChip value={`Exp: ${dayjs( video.endDate ).format( "DD/MM/YYYY, HH:mm" )}`} />}
                            {!video.expired && <CustomChip color="error" tooltipTitle='Students should watch this video before this time to get marked as present for the class.' value={`Exp: ${dayjs( video.endDate ).format( "LLL" )}`} />}
                        </Box>
                    </Box>
                </Box>

                {
                    ( ( !meeting.started &&
                        currentUserId === meeting.creator_data.user_id ) || ["ADMIN", "SUBADMIN"].includes( UserStore.getUser.user_role ) ) &&

                    <IconButton onClick={( e ) => { e.stopPropagation(); setConfirmDeleteDialogOpen( true ) }} sx={{ display: { xs: "none", sm: "inline-flex" }, flexShrink: 0, ":hover": { color: "error.main" } }}>
                        {Icons.default.DeleteIconOutlined}
                    </IconButton>
                }
                {
                    ( ( !meeting.started &&
                        currentUserId === meeting.creator_data.user_id ) || ["ADMIN", "SUBADMIN"].includes( UserStore.getUser.user_role ) ) &&

                    <Button startIcon={Icons.default.DeleteIconOutlined} variant="outlined" color="error" onClick={( e ) => { e.stopPropagation(); setConfirmDeleteDialogOpen( true ) }} sx={{ borderRadius: 5, display: { xs: "inline-flex", sm: "none" } }}>
                        Remove recording from class
                    </Button>
                }
            </Box>
        </Box>
    )
} )

const RecordingVideo = ( { video, playVideo } ) => {

    const { palette, border } = useTheme()
    const { meeting_id } = useParams()

    const play = async () => {
        try {
            const file = video.files_list?.find( file => file.key && file.key?.toLowerCase()?.endsWith( 'mp4' ) )
            if ( !file?.key ) return
            const { data: { data } } = await api.recording.fetchMeetingRecordingSignedUrl( meeting_id, { key: file.key, register_watch: false } )
            playVideo( data, video )
        } catch ( err ) {
            toast( err?.response?.data?.message || "Something went wrong while fetching video!" )
        }
    }

    return (
        <Box sx={{ cursor: "pointer", ":hover": { borderColor: palette.text.secondary } }} border={border[1]} justifyContent="space-between" padding="5px 10px" display="flex" alignItems="center" gap="10px" borderRadius="5px" bgcolor={palette.contentBg} onClick={play}>
            <Box sx={{ flexDirection: { xs: "column", sm: "row" } }} display="flex" flexGrow={1} gap="10px" >

                <Box border={border[1]} borderRadius="5px" overflow="clip" sx={{ aspectRatio: "16 / 9" }} height="120px" position="relative" flexShrink={0}>
                    <Box display="flex" alignItems="center" justifyContent="center" height="100%" bgcolor={palette.contentBg} color="text.secondary" fontSize="32px">
                        {Icons.default.OndemandVideoIcon}
                    </Box>
                    <Box position="absolute" display="flex" alignItems="center" justifyContent="center" sx={{ inset: 0, color: palette.text.primary }} fontSize="40px"  >
                        <Typography fontSize="18px" display="flex" alignItems="center" justifyContent="center" bgcolor={palette.contentBg} width="30px" borderRadius="50%" sx={{ boxShadow: 5, aspectRatio: "1 / 1" }} >{Icons.default.PlayArrowIcon}</Typography>
                    </Box>
                </Box>

                <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>
                    <Typography gutterBottom sx={{ fontSize: "1rem", fontWeight: 600 }} component="h3">Recording {dayjs( video.started_at ).format( "DD_MM_YYYY_HH:mm" )}</Typography>
                    <Box display="flex" gap="5px" alignItems="center" flexWrap="wrap">
                        <CustomChip value="Stream Recording" />
                        <CustomChip value={`Streamed ${getTimePassedFrom( video.started_at )}`} />
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

const OnlineSessionRecordingsDetails = observer( ( { setTabValue } ) => {

    const [manageAccessWindowOpen, setManageAccessWindowOpen] = useState( false )
    const [recordingLink, setRecordingLink] = useState( null )
    const [playingVideo, setPlayingVideo] = useState( null )

    const { palette, border, layout } = useTheme()
    const { meeting_id } = useParams()

    const OnlineSessionsStore = useOnlineSessionsStore()
    const SettingsStore = useSettingsStore()

    const maxExtendableTime = SettingsStore.getUseSettings?.["hybrid_class_max_video_extend_time"] || '17:20'

    const maxExtendTimeDetails = useMemo( () => {
        const hourAndMinute = maxExtendableTime.split( ":" )
        const [hour, minute] = hourAndMinute.map( i => +i )
        if ( hour && Number.isInteger( hour ) && hour > 0 && hour <= 24 && Number.isInteger( minute ) && minute >= 0 && minute <= 60 ) {
            return { hour24: leadingZeroFormatter.format( hour ), minute, hour12: leadingZeroFormatter.format( ( hour % 12 ) || 12 ) }
        } else {
            return { hour24: "17", minute: "20", hour12: "05" }
        }
    }, [maxExtendableTime] )

    const { initialLoad: loading, refreshing } = OnlineSessionsStore.getRecordingsLoadingStatus
    const meetingRecordings = OnlineSessionsStore.getStreamRecordings
    const error = OnlineSessionsStore.getErrors.onlineSessionRecordings
    const meeting = OnlineSessionsStore.getSessionMetadata

    const playVideo = async ( url, video ) => {
        try {
            setRecordingLink( url )
            setPlayingVideo( video )
        } catch ( err ) {
            toast( err?.response?.data?.message || "Something went wrong while fetching video file!" )
        }
    }

    const closeVideoPlayer = () => {
        setRecordingLink( null )
        setPlayingVideo( null )
    }

    const fetchMeetingRecordings = useCallback( async () => {
        OnlineSessionsStore.fetchOnlineSessionRecordings( meeting_id )
    }, [meeting_id, OnlineSessionsStore] )

    useEffect( () => {
        fetchMeetingRecordings()
    }, [fetchMeetingRecordings] )

    return (
        <Box padding="10px">
            <AccessTimeUpdateDialog open={manageAccessWindowOpen} setOpen={setManageAccessWindowOpen} />

            {recordingLink && <Dialog open={Boolean( recordingLink )} onClose={closeVideoPlayer} slotProps={{ paper: { sx: { maxWidth: "1024px", maxHeight: "90%", width: "100%", aspectRatio: "16 / 9" } } }} >

                <Box position="absolute" zIndex={10} top="0" borderRadius="0 0 0 50%" right="0" bgcolor={palette.common.font + "cc"}>
                    <IconButton onClick={closeVideoPlayer} sx={{ color: palette.common.bg }} >
                        {Icons.default.CloseIcon}
                    </IconButton>
                </Box>

                <VideoPlayer autoPlay key="player" title={playingVideo?.title || ""} containerstyles={{ background: palette.contentBg }} src={recordingLink} />
            </Dialog>}

            {!error && !loading && meetingRecordings.length > 0 && <Box>
                <Box display="flex" gap="10px" flexDirection="column" flexWrap='wrap'>
                    <Box marginTop="10px" display="flex" gap="10px" alignItems="center" justifyContent="space-between">
                        <Box>
                            {meetingRecordings.filter( v => v.type === "class-video" ).length !== 0 && <CustomChip value={`Uploads: ${meetingRecordings.filter( v => v.type === "class-video" ).length}`} />}
                            {meetingRecordings.filter( v => v.type !== "class-video" ).length !== 0 && <CustomChip value={`Class Recordings: `} count={meetingRecordings.filter( v => v.type !== "class-video" ).length} />}
                        </Box>
                        {meetingRecordings.filter( v => v.type !== "class-video" ).length > 0 && <Box>
                            <Badge anchorOrigin={{ vertical: "top", horizontal: "right" }} color='error' badgeContent={OnlineSessionsStore.getAccessTimeExtentionRequests?.filter( req => req.status === "pending" ).length}>
                                <Button onClick={() => setManageAccessWindowOpen( true )} startIcon={Icons.default.ManageAccounts} size='small' variant='contained' disableElevation >View Access Overrides</Button>
                            </Badge>
                        </Box>}
                    </Box>

                    {meetingRecordings?.map( ( video, index ) => {
                        if ( video.type === "recording" ) {
                            return (
                                <RecordingVideo key={video.id} video={video} playVideo={playVideo} />
                            )
                        }
                        if ( video.type !== "class-video" ) {
                            return (
                                <HybridClassVideo key={video.id} playVideo={playVideo} video={video} />
                            )
                        }
                        return null
                    } )}
                </Box>
            </Box>}
            {!error && !loading && meetingRecordings.length === 0 && <Box display="flex" flexDirection="column" gap="20px" alignItems="center" bgcolor={palette.contentBg} padding="20px" borderRadius={layout.borderRadius} >
                <Box component="img" width="200px" src={noRecordingsImg} />
                <Typography variant='subtitle2' component="p" textAlign="center">{meeting.meeting_type === "hybrid-class" ? "No recordings or videos to show" : "No recordings exists for this session."}</Typography>
                {meeting.meeting_type === "hybrid-class" && dayjs( dayjs( meeting.starts_at ).format( "YYYY-MM-DD" ) ).hour( Math.max( +( maxExtendTimeDetails?.hour24 || 21 ) - 1, 20 ) ) > dayjs() && !error && <AddNewRecordingButton setTab={setTabValue} styles={{ boxShadow: "none" }} buttonSize="small" availableVideos={meetingRecordings} refresh={fetchMeetingRecordings} classDetails={meeting.time_table_class_details} />}
            </Box>}

            {loading && <DataLoadingSpinner waitingMessage="Loading recordings please wait..." />}

            {error && <TryAgainMessageBlock parent='component' getData={fetchMeetingRecordings} loading={refreshing} code={error?.code} err={error?.message} />}
        </Box>
    )
} )

export default OnlineSessionRecordingsDetails
